import { ReactNode } from 'react';

import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import { ActivityFragment } from '@spotify/confidence-graphql';

export interface IssueActivityTypeOptions {
  activity: ActivityFragment;
}

export const IssueActivityTypeExtensions = createItemRenderExtensions({
  id: 'issue-activity-type',
});

export const useIssueActivityTypeExtensions = () => {
  return useItemRenderExtensions<
    ItemRenderExtensionOptions<IssueActivityTypeOptions>
  >(IssueActivityTypeExtensions);
};

export const createIssueActivityTypeExtension = ({
  id,
  render,
}: {
  id: string;
  render: (options: IssueActivityTypeOptions) => ReactNode;
}) => {
  const options: ItemRenderExtensionOptions<IssueActivityTypeOptions> = {
    id,
    render,
    predicate: ({ activity }: IssueActivityTypeOptions) => {
      return activity.name.startsWith(`activityTypes/${id}/`);
    },
  };

  return createItemRenderExtension<
    ItemRenderExtensionOptions<IssueActivityTypeOptions>
  >(options);
};
